import api from 'api';
import {call, delay} from 'redux-saga/effects';
import {asyncSagaConstructor} from 'redux/common';
import {backupTypes} from '..';

export function* waitUntilAllJobsStopped() {
   let resp = {result: true};
   do {
      resp = yield call(asyncSagaConstructor(api.jobsRunning, backupTypes.GET_JOBS_RUNNING));
      yield delay(1000);
   } while (resp.result);

   return resp;
}
